import {Component, QueryList, ViewChildren} from '@angular/core';
import {DateTime, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, Util} from '../../../app/util';
import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {TAction, TInvoiceFlag, TInvoiceMode} from "../../../app/enum";
import {PaybookRepo} from '../../../repositories/payment-repo';


@Component({
    selector: 'page-invoice-menu',
    templateUrl: 'invoice-menu.html',
    providers: [ProfileService, HotspotService, PaybookRepo]
})
export class InvoiceMenuPage {

    TInvoiceFlag: any = TInvoiceFlag;
    TInvoiceMode: any = TInvoiceMode;

    config: any;
    logado: any;

    profile: any;
    branded: any;
    userset: any;
    paybook: any;

    indexPN: number;

    etapa: number;

    hotspotID: number;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;
    monitorBool: boolean = true;

    comandaList: any;
    comandaLoop: number;

    flagstor: boolean;

    @ViewChildren(DateTime) iondates: QueryList<DateTime>;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public hotspotService: HotspotService,
                public viewCtrl: ViewController, public util: Util,
                public logadoService: LogadoService,
                public paybookRepo: PaybookRepo) {


        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.profile = this.navParams.get('profile');
        this.branded = this.navParams.get('branded');
        this.userset = this.navParams.get('userset');
        this.paybook = this.navParams.get('paybook');

        this.indexPN = this.navParams.get('indexPN');

        this.hotspotID = this.navParams.get('hotspotID');

        this.monitorBool = this.navParams.get('monitorBool');

        this.comandaList = this.navParams.get('comandaList');
        this.comandaLoop = -1;

        this.flagstor = this.navParams.get('flagstor');
        
        //Prepare-Nota
        this.comandaList.forEach(CO => {
            CO.Invoice = {
                ComandaID: CO.ComandaID,
                UsuarioID: 0,
                PrinterID: 0,
                DevolveID: 0,
                InvoiceID: 0,
                InvoiceFind: false,
                InvoiceMode: TInvoiceMode.nfNFC,
                InvoiceRnid: '',
                InvoiceText: '',
                
                //Controle-Tela
                InvoiceBool: true,
                InvoiceFlag: TInvoiceFlag.nfNone,
            }
        });


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Invoice Menu', '/invoice-menu');

    }




    /** ************************************************ PAYBOOK ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    getTitle() {

        if (this.etapa == 0) return 'Emissão Fiscal';
        if (this.etapa == 1) return TInvoiceMode[this.paybook.Invoices[this.indexPN].InvoiceMode].slice(2, 99);

    }

    invoiceTopo() {

        if (this.etapa == 0) return 'CorRoxa';
        if (this.etapa == 1) return 'CorRoxa';

    }

    invoiceTint(line) {

        if (line.Invoice.InvoiceFlag == TInvoiceFlag.nfNone)         return 'CorText';
        if (line.Invoice.InvoiceFlag == TInvoiceFlag.nfProcess)      return 'CorRosa';
        if (line.Invoice.InvoiceFlag == TInvoiceFlag.nfContingencia) return 'CorAzul';
        if (line.Invoice.InvoiceFlag == TInvoiceFlag.nfRejeitada)    return 'CorVerm';
        if (line.Invoice.InvoiceFlag == TInvoiceFlag.nfEmitida)      return 'CorMenu';
        if (line.Invoice.InvoiceFlag == TInvoiceFlag.nfDenegada)     return 'CorCafe';
        if (line.Invoice.InvoiceFlag == TInvoiceFlag.nfCancelada)    return 'CorVerm';
        if (line.Invoice.InvoiceFlag == TInvoiceFlag.nfInutiliza)    return 'CorFogo';

    }





    /** ************************************************ INVOICE ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    invoiceFlag() {

    }

    invoiceEmit() {

        this.comandaLoop++;
        let paybook = this.comandaList[this.comandaLoop];
        if (!paybook) return;

        if (!paybook.Invoice.InvoiceBool) {
            this.invoiceEmit();
            return;
        }


        let onOkay = (data) => {
            paybook.Invoice.InvoiceFlag = TInvoiceFlag[data.InvoiceFlag];
            
            let invoice = this.util.deepCopy(paybook.Invoice);
            if (!paybook.Invoices) paybook.Invoices = [];
            paybook.Invoices.push(invoice);
            //delete paybook.Invoice;

            if (this.comandaList.length == this.util.jsCount(this.comandaList, ['Invoice', 'InvoiceFlag'], 'InvoiceFlag', [TInvoiceFlag.nfEmitida])) {
                this.dismiss();
                return;
            }

            this.invoiceEmit();
        }

        let onErro = (erro) => {
            paybook.Invoice.InvoiceFlag = TInvoiceFlag.nfRejeitada;
            paybook.Invoice.InvoiceErro = erro.Result;
            this.invoiceEmit();
        }

        let loading = this.util.loadingDots();
        loading.present();

        let hotspotID = this.monitorAuth.Hotspot.HotspotID;
      //this.util.monitorDesk(this.monitorBool, 'DESK-Invoice', hotspotID, '', TAction.acEmit, paybook.Invoice) // nao deveria ser essa request?
        this.util.monitorDesk(this.monitorBool, 'DESK-Emissor', hotspotID, '', TAction.acEmit, paybook.Invoice)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onOkay(data),
                erro => onErro(erro),
            );

    }




    dismiss() {

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss({}, 'back');
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/invoice-menu/invoice-menu.ts